// extracted by mini-css-extract-plugin
export default {"ChatPageInner":"PrescriptionPage_ChatPageInner__f-dsM","card":"PrescriptionPage_card__dRSxD"};